
function reducer(state = [], action) {
    switch (action.type) {
        case 'WAIVERS/SET':            
            return action.waivers;
        case 'WAIVERS/CLEAR':
            return null;
        default:
            return state;
    }
}

export default reducer;